import { AccountCreation } from "@/components/signup/account-creation/account-creation";
import { SignupBackgroundLayout } from "@/components/signup/layouts/signup-background-layout";
import { RovoDevAgentsLogo } from "@/components/signup/utils/logos/rovo-dev-agents-logo";

import { RovoDevGetStartedHeading } from "../../components/get-started-heading";

export const LoggedOutRovoDevStandard = () => {
    return (
        <SignupBackgroundLayout
            theme="green"
            ProductLogo={<RovoDevAgentsLogo />}
        >
            <RovoDevGetStartedHeading />
            <AccountCreation />
        </SignupBackgroundLayout>
    );
};
